export const LOADER_START = 'LOADER_START';
export const LOADER_STOP = 'LOADER_STOP';